import Analytics from '@withlocals/withlocals-analytics';
import Modal from 'components/Modal';
import ModalBody from 'components/Modal/ModalBody';
import ModalFooter from 'components/Modal/ModalFooter';
import Paragraph from 'components/Paragraph';
import RoundedButton from 'components/RoundedButton';
import WarningIcon from 'components/icons/WarningIcon';
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const CSS = require('./EmptyModal.module.scss');

function EmptyModal({ formName }) {
  const history = useHistory();
  const location = useLocation<any>();

  const onReturn = () => {
    Analytics.track(formName, 'Empty model', 'Return to selection');
    return history.goBack();
  };
  const onDiscard = () => {
    Analytics.track(formName, 'Empty model', 'Discard changes');
    return !location.state?.origin
      ? history.replace('/host/profile/')
      : history.go(-2);
  };

  const onCloseModal = () => {
    Analytics.track(formName, 'Empty model', 'Close modal');
    return history.goBack();
  };

  return (
    <Modal show onClose={onCloseModal} className={CSS.Modal}>
      <ModalBody>
        <h1 className={CSS.Title}>
          <WarningIcon className={CSS.WarningIcon} /> Whoops, you don't have any
          option selected!
        </h1>
        <Paragraph>Please select minimum 1 option to continue.</Paragraph>
      </ModalBody>
      <ModalFooter className={CSS.Footer}>
        <RoundedButton
          className={CSS.Button}
          size="S"
          onClick={onDiscard}
          invertedBorder
        >
          Discard changes
        </RoundedButton>
        <RoundedButton className={CSS.Button} size="S" onClick={onReturn}>
          Return to selection
        </RoundedButton>
      </ModalFooter>
    </Modal>
  );
}

export default EmptyModal;
